export default __webpack_public_path__ + "static/MediaContentFive-6287159728e87c7398d0abd615190080.webp";